import { config } from "../../config";
import { SharedSpinnerService } from "../../models/shared/spinner/sharedSpinnerService";

class FileService {
  private apiKey?: string;
  private fingerprint?: string;
  private queue: Array<() => void> = [];
  private memo: Record<string, Promise<string>> = {};
  private spinnerService?: SharedSpinnerService;

  public setSpinnerService(spinnerService: SharedSpinnerService) {
    this.spinnerService = spinnerService;
  }

  public setApiKey(apiKey?: string) {
    this.apiKey = apiKey;
    if (this.apiKey) {
      const queue = [...this.queue];
      this.queue.length = 0;
      queue.forEach((cb) => cb());
    }
  }

  public setFingerprint(fingerprint?: string) {
    this.fingerprint = fingerprint;
  }

  private doFetch(url: string) {
    return fetch(url, {
      headers: {
        ...(this.apiKey ? { "x-api-key": this.apiKey } : {}),
        ...(this.fingerprint ? { "x-fingerprint": this.fingerprint } : {}),
      }
    }).then((r) => r.blob())
      .then((b) => window.URL.createObjectURL(b));
  }

  public getDataUrl(url: string) {
    if (!this.memo[url]) {
      if (!this.apiKey) {
        this.memo[url] = new Promise((resolve, reject) =>
          this.queue.push(() =>
            this.doFetch(url).then(resolve).catch(reject))
        );
      } else {
        this.memo[url] = this.doFetch(url);
      }
    }
    return this.memo[url]!;
  }

  private getWheelhouseToken(url: string): string | undefined {
    const parsedURL = new URL(url);
    if (parsedURL?.hostname === config.services.wheelhouse.hostname && parsedURL?.pathname.startsWith("/api/resources/files/")) {
      return parsedURL.pathname.split("/")[4];
    }

    return;
  }

  private getWheelhouseUrl(token: string): string {
    return `${config.services.wheelhouse.baseUrl}/resources/files/t/${token}`;
  }

  public async getOneTimeLink(url: string) {
    const wheelhouseToken = this.getWheelhouseToken(url);
    const urlToOpen = wheelhouseToken && this.spinnerService
      ? this.getWheelhouseUrl(await this.spinnerService.getTemporaryToken(wheelhouseToken))
      : url;
    return urlToOpen;
  }
}

export const fileService = new FileService();
